import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import axios from 'axios';
import LoadingImage from '../Images/loading.gif';
import ErrorPage from './Errorpage';
 
const PegaLTSS = () => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [memberState, setMemberState] = useState('');
  const location = useLocation();
  const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';
 
  useEffect(() => {
    try {
      window.history.pushState("you are being redirected...", "Redirect", "/redirect");
    } catch (err) {
      if (typeof console !== 'undefined') console.log(err);
    }
   
    // Dynamically extract all query parameters without altering case
    const queryParams = new URLSearchParams(location.search);
    const params = {};
    queryParams.forEach((value, key) => {
      params[key] = value; // Keep keys as they are
    });
 
    console.log('Extracted Query Parameters:', params); // Log the extracted parameters
   
    fetchPegaLTSSURL(params);
  }, [location]);
 
  const fetchPegaLTSSURL = async (params) => {
    try {
      console.log('Request parameters:', params);
      const response = await axios.get(`${API_URL}/api/PegaLTSS/GetPegaLTSSUrl`, {
        params: {
          ...params
        }
      });
 
      console.log('API Response:', response.data);
     
      setLoading(false);
     
      if (response.data && response.data.url) {
        // Always use direct window location redirect like InSignia.js
        window.location.href = response.data.url;
       
      
        
      } else {
        setLoading(false);
        if (response.data && response.data.Message) {
          setError(response.data.Message);
        } else {
          setError('pegaltss');
          setMemberState(response.data.MemberState || '');
        }
      }
    } catch (error) {
      console.error('Error fetching Pega LTSS URL:', error);
      setLoading(false);
      
      // Handle BadRequest and other HTTP errors
      if (error.response && error.response.status === 404) {
        // Handle BadRequest - extract message from response
        const errorMessage = error.response.data?.message || 'Bad request occurred';
        setError(errorMessage);
      } else if (error.response) {
        // Handle other HTTP errors
        const errorMessage = error.response.data?.message || `HTTP Error: ${error.response.status}`;
        setError(errorMessage);
      } else {
        // Handle network or other errors
        setError('pegaltss');
      }
    }
  };
  // Form submission removed - using direct window.location.href like InSignia.js
 
  return (
    <div>
      <table style={{backgroundColor: 'transparent'}} cellPadding="0" cellSpacing="0">
        <tbody>
          <tr style={{height: '30%'}}>
            <td></td>
          </tr>
          <tr>
            <td style={{width: '30%'}}></td>
            <td align="center" style={{fontSize: 'x-large'}}>
              {/* {error && (
                error.includes(memberState) ? (
                  <div id="divErrorState" style={{color: 'red'}}>
                    Pega LTSS not available for <b>{memberState}</b> state
                  </div>
                ) : (
                  <ErrorPage errorType="pegaltss"
                    customMessage={error !== 'pegaltss' ? error : undefined}
                  />
                )
              )} */}
               {error && <ErrorPage errorType="pegaltss" customMessage={error} />}
            </td>
            <td style={{width: '30%'}}></td>
          </tr>
          <tr>
            <td style={{width: '50%'}}></td>
            <td align="center" style={{fontSize: 'large'}}>
              {loading && (
                <div>
                  <div style={{float: 'left'}}>
                    <img id="loadinggif" src={LoadingImage} alt="Loading" />
                  </div>
                  <div id="loadingtext" style={{float: 'left'}}>
                    Loading...
                  </div>
                </div>
              )}
            </td>
            <td style={{width: '50%'}}></td>
          </tr>
          <tr>
            <td style={{width: '30%'}}></td>
            <td align="center">
              <div style={{fontSize: 'larger'}}></div>
            </td>
            <td style={{width: '30%'}}></td>
          </tr>
          <tr style={{height: '30%'}}>
            <td></td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};
 
export default PegaLTSS;